import React, { useEffect, useState } from "react";
import { Icon, Loader, Table } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 as api } from "../../../../services/apis";
import { Container, Content, Center, Link, Nav } from './styled'
import { datePattern, formatValue } from '../../../../utils/Utils';
import { useRouter } from "../../../../hooks/router";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import Status from '../../../../components/Admin/Pagarme/Status';


const PagarmeInadimplentes = () => {
  const [loading, setLoading] = useState(false);
  const [faturas, setFaturas] = useState(null)
  const [page, setPage] = useState(1)

  useEffect(() => {
    setLoading(true)
    api.get(`/pagarme/faturas?page=${page}`).then(res => {
      console.log(res.data)
      setFaturas(res.data.itens)
      setLoading(false)
    }).catch(err => {
      setLoading(false)
    })

  }, [page])

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Content>
          <h2>Aluno inadimplentes</h2>
          <Nav>
            <button onClick={() => setPage(page - 1)}>
              <FaArrowLeft />
            </button>
            <button onClick={() => setPage(page + 1)}>
              <FaArrowRight />
            </button>
          </Nav>
          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>
                <Center>Id pedido</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Aluno</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Valor</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Status</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Parcela</Center>
              </Table.HeaderCell>
              {/* <Table.HeaderCell>
                <Center>Status assinatura</Center>
              </Table.HeaderCell> */}
              <Table.HeaderCell>
                <Center>Data cobrança</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Ação</Center>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {loading ? <Loader active={loading} /> :
                faturas && faturas.length !== 0 ? faturas.map((fatura) => (
                  <Table.Row>
                    <Table.Cell>
                      <Center>{fatura.id_pedido}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>[{fatura.id_pessoa}]: {fatura.customer.name} <br /> {fatura.customer.email}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>{formatValue(fatura.amount)}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        <Status status={fatura.status} />
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>{fatura.cycle.cycle}</Center>
                    </Table.Cell>
                    {/* <Table.Cell>
                      <Center>{fatura.subscription.status}</Center>
                    </Table.Cell> */}
                    <Table.Cell>
                      <Center>{datePattern(fatura.created_at)}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        <Link href={`/admin/pagarme/assinante/${fatura.id_pessoa}`} target='_blank' >Abrir</Link>
                      </Center>
                    </Table.Cell>
                  </Table.Row>
                )) : <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan='7'>
                      <Center>Aluno não encontrado :( </Center>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>}
            </Table.Body>
          </Table>
        </Content>
      </Container>
    </div>
  );
};

export default PagarmeInadimplentes;

